import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return (
        <svg {...validProps} viewBox={'0 0 100 100'}>
            <g className='background-fill'>
                <path d='M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0Zm0,90A40,40,0,1,1,90,50,40,40,0,0,1,50,90Z' />
                <path d='M26,74,59.19,59.19,74,26,40.81,40.81ZM64.14,35.86,57.59,50.52l-8.11-8.11Z' />
            </g>
            <g className='outline'>
                <path d='M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0Zm0,97A47,47,0,1,1,97,50,47.05,47.05,0,0,1,50,97Z' />
                <path d='M50,7A43,43,0,1,0,93,50,43,43,0,0,0,50,7Zm0,83A40,40,0,1,1,90,50,40,40,0,0,1,50,90Z' />
                <path d='M26,74,59.19,59.19,74,26,40.81,40.81ZM68.1,31.9l-11.18,25L31.9,68.1l11.18-25Z' />
            </g>
        </svg>
    );
}
SvgComponent.iconName = 'joyride-introduction';

export const JoyrideIntroductionIcon = svgIconWrapper(SvgComponent);
